import Debug from './debug.js';
import descriptions from './descriptions.js';
import { getCombinedConfig } from './config.js';

const debug = Debug('base');

const baseBuilder = (yargs) => {
  return yargs;
};

const baseApiBuilder = async (yargs) => {
  debug('builder');
  const config = await getCombinedConfig();

  return baseBuilder(yargs)
    .option('apikey', descriptions.options['apikey'].config)
    .option('env', descriptions.options['env'].config)
    .option('json', descriptions.options['json'].config)
    .config(config)
    .demandOption(['env'], descriptions.options['env'].demandText)
    .demandOption(['apikey'], descriptions.options['apikey'].demandText);
};

export { baseBuilder, baseApiBuilder };
